/* import __COLOCATED_TEMPLATE__ from './add-payout-method.hbs'; */
import { computed } from '@ember/object';
import { oneWay } from '@ember/object/computed';
import { A } from '@ember/array';
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-add-payout-method';

export default Component.extend({
  classNames: [CLASS_NAME, 'LSG-l-grid', 'justify-center'],
  CLASS_NAME,

  /** @param {Ember.A<Country>} */
  countries: A([]),

  /** @param {Ember.A<PayoutMethod>} */
  payoutMethods: A([]),

  /** @param {HyperwalletUser|null} */
  hyperwalletUser: null,

  /** @param {Function} */
  onMethodSelect: () => {},

  /** @type {String|undefined} */
  selectedCountryCode: oneWay('hyperwalletUser.country'),

  /** @param {Boolean} */
  isLoading: false,

  /** @type {Ember.A<Object>} */
  countryOptions: computed('countries.@each.{code,name}', 'payoutMethods.@each.country', function () {
    const validCountriesMap = new Map(this.payoutMethods.map((method) => [method.country, true]));

    return this.countries.reduce((countries, country) => {
      if (validCountriesMap.has(country.code)) {
        countries.push({
          key: country.name,
          model: country,
        });
      }
      return countries
    },
    []).sort((countryA, countryB) => countryA.key.localeCompare(countryB.key));
  }),

  /** @type {String} */
  selectedCountryName: computed('countries.[]', 'selectedCountryCode', function () {
    const selectedCountry = this.get('countries')
      .find((country) => country.get('code') === this.get('selectedCountryCode'));
    
    return selectedCountry ? selectedCountry.get('name') : '';
  }),

  /** @type {Ember.A<PayoutMethod>} */
  availablePayoutMethods: computed('payoutMethods.[]', 'selectedCountryCode', function () {
    return this.get('payoutMethods')
      .filter((payoutMethod) => payoutMethod.get('country') === this.get('selectedCountryCode'));
  }),

  actions: {
    handleCountryChange(country) {
      this.set('selectedCountryCode', country.get('code'));
    },

    handleMethodSelect(payoutMethod) {
      this.get('onMethodSelect')(payoutMethod, this.get('selectedCountryCode'));
    },
  },
});
